import type { ReactNode } from "react"
import BaseTopUpRequest from "./BaseTopUpRequest"


/**
 * Props interface for the AddRaiseETopUpRequest component
 * @property {ReactNode} children - Child components to render within the form
 */
type Props = {
  children?: ReactNode
}

export default function AddRaiseETopUpRequest({ children }: Props) {
  return (
    <BaseTopUpRequest showWalletSelection={true} showPaymentTypeSelection={true} defaultPaymentType="advance">
      {children}
    </BaseTopUpRequest>
  )
}
